import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateLogisticWeightRangeInput,
    LogisticWeightRange,
    UpdateLogisticWeightRangeInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class LogisticWeightRangeService {
    private amplifyClient = generateClient();
    constructor() {}

    async getLogisticWeightRange(id: string): Promise<LogisticWeightRange> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getLogisticWeightRange,
                    variables: {
                        id
                    }
                })
            ).data.getLogisticWeightRange;
            if (data) return data as LogisticWeightRange;
        } catch (error) {
            console.error('Error finding LogisticZone:', error);
            return null;
        }
    }

    async listLogisticWeightRanges(): Promise<LogisticWeightRange[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listLogisticWeightRanges
                })
            ).data.listLogisticWeightRanges.items;
            if (data) return data as LogisticWeightRange[];
        } catch (error) {
            console.error('Error finding LogisticWeightRange:', error);
            return null;
        }
    }

    async listAllLogisticWeightRanges(
        pageLimit: number = 100
    ): Promise<LogisticWeightRange[]> {
        const ranges: LogisticWeightRange[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.listLogisticWeightRanges,
                        variables: {
                            limit: pageLimit,
                            nextToken
                        }
                    })
                ).data.listLogisticWeightRanges;
                ranges.push(
                    ...((response?.items ?? []) as LogisticWeightRange[])
                );
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return ranges;
        } catch (error) {
            console.error('Error finding LogisticWeightRange:', error);
            return [];
        }
    }

    async createLogisticWeightRange(
        input: CreateLogisticWeightRangeInput
    ): Promise<LogisticWeightRange> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createLogisticWeightRange,
                    variables: {
                        input
                    }
                })
            ).data.createLogisticWeightRange;
            if (date) return date as LogisticWeightRange;
        } catch (error) {
            console.error('Error creating LogisticWeightRange:', error);
            return null;
        }
    }
    async updateLogisticWeightRange(
        input: UpdateLogisticWeightRangeInput
    ): Promise<LogisticWeightRange> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateLogisticWeightRange,
                    variables: {
                        input
                    }
                })
            ).data.updateLogisticWeightRange;
            if (date) return date as LogisticWeightRange;
        } catch (error) {
            console.error('Error updated LogisticWeightRange:', error);
            return null;
        }
    }
}
